import { gql } from '@apollo/client/core';

export const GetAssociateSearch = gql`
    query GetAssociateSearch(
        $customerId: String
        $firstName: String
        $lastName: String
        $captcha: String
    ) {
        getAssociateSearch(
            customerId: $customerId
            firstName: $firstName
            lastName: $lastName
            captcha: $captcha
        ) {
            searchResultsCount
            results {
                firstName
                lastName
                customerId
                classification
                district
            }
        }
    }
`;
